import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  amDataService,
  loaderService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-preparation-item-report.controller';
import directive from './attach-preparation-item-report.directive';


export default angular.module('app.components.advisory.auditTrail.attachPreparationItemReport', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('amAttachPreparationItemReport', directive)
  .controller('AttachPreparationItemReportController', controller)
  .name;

console.log('app.components.advisory.auditTrail.attachPreparationItemReport created');
